import add_icon from "./add_icon.svg";
import admin_logo from "./admin_logo.svg";
import admin_logo_white from "./admin_logo_white.svg";
import appointment_icon from "./appointment_icon.svg";
import cancel_icon from "./cancel_icon.svg";
import careGiver_icon from "./careGiver_icon.svg";
import home_icon from "./home_icon.svg";
import people_icon from "./people_icon.svg";
import upload_area from "./upload_area.svg";
import list_icon from "./list_icon.svg";
import tick_icon from "./tick_icon.svg";
import appointments_icon from "./appointments_icon.svg";
import earning_icon from "./earning_icon.svg";
import clientsg_icon from "./clientsg_icon.svg";
import vetting from "./vetting.svg";
import clients from "./clients.svg";
import caregivers from "./caregivers.jpg";
import not_found from "./notFound.webp";

export const assets = {
  add_icon,
  admin_logo,
  appointment_icon,
  cancel_icon,
  careGiver_icon,
  upload_area,
  home_icon,
  clientsg_icon,
  people_icon,
  list_icon,
  tick_icon,
  appointments_icon,
  earning_icon,
  vetting,
  clients,
  caregivers,
  admin_logo_white,
  not_found,
};
